import type { ResourceResult } from '~/client/src/shared/resources/domain/resourceResult'
import type { SensorResourceFailure } from '~/client/src/shared/resources/domain/sensorResourceTypeDefinition'

export function requireSensorResourceSuccess<T>(
  result: ResourceResult<T, SensorResourceFailure>,
): T {
  if (result._tag === 'Ok') return result.value
  if (
    result.error._tag === 'ProjectResourceOperationFailure' &&
    result.error.cause instanceof Error
  ) {
    throw result.error.cause
  }

  switch (result.error._tag) {
    case 'MissingSensorResourceRecord':
      throw new Error(`Cannot save missing StruxTag: ${result.error.recordId}`)
    case 'MissingSensorResourceId':
      throw new Error('StruxTag response did not contain an id')
    case 'MissingSensorInfuseId':
      throw new Error('Infuse ID is required')
    case 'SensorInfuseIdContainsSpaces':
      throw new Error('Infuse ID must not contain spaces')
    case 'ProjectResourceOperationFailure':
      throw new Error(`StruxTag operation failed: ${result.error.operation}`)
  }
}
